import { EmeraldMenu } from '@emerald-react/menu';
import type { ComponentProps } from 'react';
import './styles.scss';

export type MenuProps = ComponentProps<typeof EmeraldMenu>;

export function Menu(props: MenuProps) {
  return <EmeraldMenu {...props} />;
}
